import { POINTS_CIRCLE_LAYER } from './constants';
import { handleMapClick, handleSelectPoint } from './MapMarkers';

/**
 * Create and attach map click event handler
 */
export const createMapClickHandler = (
  map, 
  locations, 
  currentMode, 
  setupSubmode, 
  setLocations
) => {
  return (e) => {
    // Don't handle clicks if map isn't loaded
    if (!map || !map.loaded()) return;
    
    // Call map click handler from MapMarkers with required parameters
    handleMapClick(e, {
      currentMode,
      setupSubmode,
      locations,
      setLocations
    });
  };
};

/**
 * Create and attach point click event handler
 */
export const createPointClickHandler = (
  map, 
  locations, 
  startId, 
  currentMode, 
  setStartId, 
  onMapPointSelect
) => {
  // Log when creating click handler

  if (currentMode === 'Custom Path' && !onMapPointSelect) {
    console.warn('[DEBUG-MAP] Warning: Creating point click handler for Custom Path mode without callback!');
  }
  
  return (e) => {
    // Don't handle clicks if map isn't loaded
    if (!map || !map.loaded()) {

      return;
    }

    // Get features at click point
    const features = map.queryRenderedFeatures(e.point);

    // If clicked on a point
    if (features.length > 0) {
      // Get point ID from feature properties
      const pointId = features[0].properties.id;

      // Perform detailed callback validation
      if (onMapPointSelect) {
        const callbackType = typeof onMapPointSelect;

        if (callbackType !== 'function') {
          console.error(`[DEBUG-MAP] Invalid callback type: expected function, got ${callbackType}`);
          return;
        }
      } else {
        console.warn(`[DEBUG-MAP] onMapPointSelect callback is ${onMapPointSelect}`);
        
        // Extra callback verification for debugging
        if (currentMode === 'Custom Path') {
          console.error('[DEBUG-MAP] No point selection callback available in Custom Path mode');
          return; // Early return if no callback in Custom Path mode
        }
      }
      
      // Call point selection handler with detailed parameters
      handleSelectPoint({
        map,
        pointId,
        locations,
        startId,
        currentMode,
        setStartId,
        onMapPointSelect
      });
    }
  };
}; 